interface UserTypeSelectorProps {
  isPro: boolean;
  onProChange: (isPro: boolean) => void;
}

export const UserTypeSelector = ({ isPro, onProChange }: UserTypeSelectorProps) => {
  return (
    <div className="space-y-2">
      <button
        onClick={() => onProChange(true)}
        className={`w-full p-3 rounded-lg transition-all ${
          isPro
            ? "bg-primary text-white"
            : "bg-gray-100 hover:bg-gray-200"
        }`}
      >
        1 mois offert pour automatiser vos réservations
      </button>
      <button
        onClick={() => onProChange(false)}
        className={`w-full p-3 rounded-lg transition-all ${
          !isPro
            ? "bg-primary text-white"
            : "bg-gray-100 hover:bg-gray-200"
        }`}
      >
        1 accès early à la carte des pépites
      </button>
    </div>
  );
};